import Vue from 'vue'
import {permissionsFunction} from "./reusableFunctions";

Vue.directive('permissions', {
  bind: function(el, binding){
    if(permissionsFunction(binding.value) === false){
      el.classList.add('noPermission');
    }
  }
});

Vue.directive('permissionstab', {
  bind: function(el, binding){
    if(permissionsFunction(binding.value) === false){
     return "disable"
    }
  }
});



// WEBPACK FOOTER //
// ./src/assets/js/permissions.js